var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-content"},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/img/img10.png")},on:{"click":function($event){return _vm.goBack()}}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('i',{staticClass:"el-icon-s-home home",on:{"click":_vm.goHome}})])
}
var staticRenderFns = []

export { render, staticRenderFns }